// src/components/ErrorBoundary.jsx
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="section" style={{ minHeight: "60vh", display: "flex", alignItems: "center" }}>
          <div className="container">
            <div style={{ 
              maxWidth: "600px", 
              margin: "0 auto", 
              textAlign: "center",
              padding: "3rem 2rem",
              backgroundColor: "var(--color-bg-alt)",
              borderRadius: "12px",
              border: "1px solid var(--color-border)"
            }}>
              <div style={{ 
                fontSize: "4rem", 
                marginBottom: "1.5rem",
                color: "var(--color-danger)"
              }}>
                ⚠️
              </div>
              <h2 style={{ 
                fontWeight: 700, 
                marginBottom: "1rem",
                fontSize: "1.5rem",
                color: "var(--color-text)"
              }}>
                Страница сломалась
              </h2>
              <p style={{ 
                color: "var(--color-text-secondary)",
                marginBottom: "0.5rem",
                fontSize: "0.9375rem"
              }}>
                Произошла непредвиденная ошибка при рендеринге страницы.
              </p>
              {this.state.error && (
                <p style={{ 
                  color: "var(--color-danger)",
                  fontSize: "0.875rem",
                  fontFamily: "monospace",
                  backgroundColor: "var(--color-bg)",
                  padding: "0.75rem",
                  borderRadius: "8px",
                  marginBottom: "1.5rem",
                  wordBreak: "break-word"
                }}>
                  {this.state.error.message}
                </p>
              )}
              <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
                <button 
                  className="btn btn-primary-custom"
                  onClick={this.handleReload}
                >
                  🔄 Перезагрузить
                </button>
                <button 
                  className="btn btn-outline-custom"
                  onClick={this.handleGoHome}
                >
                  🏠 На главную
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
